"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  A: true,
  anchorStyle: true,
  Body: true,
  bodyStyle: true,
  Breadcrumb: true,
  ButtonText: true,
  Caption: true,
  Chip: true,
  ChipStyles: true,
  ScoreChip: true,
  H1: true,
  H2: true,
  H3: true,
  IconHeader: true,
  Link: true,
  Overline: true,
  P: true,
  PageTitle: true,
  StatisticHeader: true,
  StatusHeader: true,
  Strong: true,
  Subtitle: true,
  Subtitle2: true
};
Object.defineProperty(exports, "A", {
  enumerable: true,
  get: function get() {
    return _A.default;
  }
});
Object.defineProperty(exports, "anchorStyle", {
  enumerable: true,
  get: function get() {
    return _A.anchorStyle;
  }
});
Object.defineProperty(exports, "Body", {
  enumerable: true,
  get: function get() {
    return _Body.default;
  }
});
Object.defineProperty(exports, "bodyStyle", {
  enumerable: true,
  get: function get() {
    return _Body.bodyStyle;
  }
});
Object.defineProperty(exports, "Breadcrumb", {
  enumerable: true,
  get: function get() {
    return _Breadcrumb.default;
  }
});
Object.defineProperty(exports, "ButtonText", {
  enumerable: true,
  get: function get() {
    return _ButtonText.default;
  }
});
Object.defineProperty(exports, "Caption", {
  enumerable: true,
  get: function get() {
    return _Caption.default;
  }
});
Object.defineProperty(exports, "Chip", {
  enumerable: true,
  get: function get() {
    return _Chip.default;
  }
});
Object.defineProperty(exports, "ChipStyles", {
  enumerable: true,
  get: function get() {
    return _Chip.ChipStyles;
  }
});
Object.defineProperty(exports, "ScoreChip", {
  enumerable: true,
  get: function get() {
    return _Chip.ScoreChip;
  }
});
Object.defineProperty(exports, "H1", {
  enumerable: true,
  get: function get() {
    return _H.default;
  }
});
Object.defineProperty(exports, "H2", {
  enumerable: true,
  get: function get() {
    return _H2.default;
  }
});
Object.defineProperty(exports, "H3", {
  enumerable: true,
  get: function get() {
    return _H3.default;
  }
});
Object.defineProperty(exports, "IconHeader", {
  enumerable: true,
  get: function get() {
    return _IconHeader.default;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _Link.default;
  }
});
Object.defineProperty(exports, "Overline", {
  enumerable: true,
  get: function get() {
    return _Overline.default;
  }
});
Object.defineProperty(exports, "P", {
  enumerable: true,
  get: function get() {
    return _P.default;
  }
});
Object.defineProperty(exports, "PageTitle", {
  enumerable: true,
  get: function get() {
    return _PageTitle.default;
  }
});
Object.defineProperty(exports, "StatisticHeader", {
  enumerable: true,
  get: function get() {
    return _StatisticHeader.default;
  }
});
Object.defineProperty(exports, "StatusHeader", {
  enumerable: true,
  get: function get() {
    return _StatusHeader.default;
  }
});
Object.defineProperty(exports, "Strong", {
  enumerable: true,
  get: function get() {
    return _Strong.default;
  }
});
Object.defineProperty(exports, "Subtitle", {
  enumerable: true,
  get: function get() {
    return _Subtitle.default;
  }
});
Object.defineProperty(exports, "Subtitle2", {
  enumerable: true,
  get: function get() {
    return _Subtitle2.default;
  }
});

var _A = _interopRequireWildcard(require("./A"));

var _Body = _interopRequireWildcard(require("./Body"));

var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));

var _ButtonText = _interopRequireDefault(require("./ButtonText"));

var _Caption = _interopRequireDefault(require("./Caption"));

var _Chip = _interopRequireWildcard(require("./Chip"));

var _H = _interopRequireDefault(require("./H1"));

var _H2 = _interopRequireDefault(require("./H2"));

var _H3 = _interopRequireDefault(require("./H3"));

var _IconHeader = _interopRequireDefault(require("./IconHeader"));

var _Link = _interopRequireWildcard(require("./Link"));

Object.keys(_Link).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Link[key];
    }
  });
});

var _Overline = _interopRequireDefault(require("./Overline"));

var _P = _interopRequireDefault(require("./P"));

var _PageTitle = _interopRequireDefault(require("./PageTitle"));

var _StatisticHeader = _interopRequireDefault(require("./StatisticHeader"));

var _StatusHeader = _interopRequireDefault(require("./StatusHeader"));

var _Strong = _interopRequireDefault(require("./Strong"));

var _Subtitle = _interopRequireDefault(require("./Subtitle"));

var _Subtitle2 = _interopRequireDefault(require("./Subtitle2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }